export default __webpack_public_path__ + "images/slide_2.jpeg?8324d41689b346c5285720afb58d7a88";